/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2023 - 2023
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Spinner from "../../icons/Spinner";
import messages from "../../../helpers/messages";

function CapacityMatchingProgressState() {
  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {messages.capacityMatchingProgressBannerMessage.defaultMessage}
      </p>
      <Spinner
        height="24"
        width="24"
        fill="#ADAFB2"
        className="fr spinner mt-12 mr-24"
      />
    </>
  );
}

export default CapacityMatchingProgressState;
